import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import StatisticDashboard from "ui/organizms/StatisticDashboard";

const StatisticDashboardScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Dashboard'
    >
        <StatisticDashboard />
    </Screen>
);

export default memo(StatisticDashboardScreen);
